import React from 'react';
import * as yup from 'yup';
import { TabbedShowcase } from '@web/components';
import { nullableImageFromCMSSchema, richTextFromCMSSchema } from '../schemas';
import { CMSBlok } from '../CMSBlok';

export const component = TabbedShowcase;

const tabPanelSchema = yup
  .object({
    tabLabel: yup.string(),
    activeLabelColor: yup.string(),
    inactiveLabelColor: yup.string(),
    headline: yup.string(),
    typography: yup.string().nullable(),
    fontColor: yup.string().nullable(),
    subheadline: richTextFromCMSSchema.nullable(),
    image: nullableImageFromCMSSchema,
    mobileImageHorizontalPosition: yup.number().nullable(),
    backgroundColor: yup.string().nullable(),
    overlay: yup.array(yup.object()),
  })
  .transform(value => ({
    tabLabel: value.tab_label,
    activeLabelColor: value.active_label_color || undefined,
    inactiveLabelColor: value.inactive_label_color || undefined,
    headline: value.headline,
    typography: value.typography || undefined,
    fontColor: value.font_color || undefined,
    subheadline: value.subheadline,
    image: value.image,
    mobileImageHorizontalPosition:
      value.mobile_image_horizontal_position === '' ||
      isNaN(Number(value.mobile_image_horizontal_position))
        ? undefined
        : Number(value.mobile_image_horizontal_position),
    backgroundColor: value.background_color || undefined,
    overlay:
      value.overlay?.map(innerContent => (
        <CMSBlok key={innerContent._uid} content={innerContent} />
      )) || [],
  }));

export const schema = yup
  .object({
    headline: yup.string().nullable(),
    subheadline: richTextFromCMSSchema.nullable(),
    headlineTypography: yup.string().nullable(),
    fontColor: yup.string().nullable(),
    backgroundColor: yup.string().nullable(),
    tabPanels: yup.array(tabPanelSchema),
  })
  .transform(value => ({
    headline: value.headline,
    subheadline: value.subheadline,
    headlineTypography: value.typography || undefined,
    fontColor: value.font_color || undefined,
    backgroundColor: value.background_color || undefined,
    tabPanels: value.tab_panels || [],
  }));
